import script from "./AdminManageDocumentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminManageDocumentsView.vue?vue&type=script&setup=true&lang=js"

import "./AdminManageDocumentsView.vue?vue&type=style&index=0&id=6d0800a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d0800a1"]])

export default __exports__